import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class ControlService {
  public myurl=url+"control/";


  constructor(private http:HttpClient) {
    
   }
  
  getListControl(){
   return this.http.get(this.myurl + "listControl.php").pipe(map(res=>{

      return res;
    }));
  }
  getIdControl(id){
    let headers=new HttpHeaders();
    let body=JSON.stringify([{"id":id}]);
   
    headers.append('Content-Type' , 'application/json');
    return this.http.post(this.myurl+"controlId.php",body,{headers:headers}).pipe(map(res=>{
      
       return res;
     }));
   }

  createControl(product:any){
    let headers=new HttpHeaders();
    let body=JSON.stringify(product);
    headers.append('Content-Type' , 'application/json');
   
    return this.http.post(this.myurl+"createControl.php",body,{headers:headers}).pipe(map(resp=>{
      return resp;
    }))
  }
  updateControl(control:any){
    let headers=new HttpHeaders();
    let body=JSON.stringify(control);
    headers.append('Content-Type' , 'application/json');
   
    return this.http.put(this.myurl+"updateControl.php",body,{headers:headers}).pipe(map(resp=>{
      return resp;
    }));
  }
  deleteControl(id){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    
    const params = new HttpParams()
    .set('id',id.toString());
    
    return this.http.delete(this.myurl+"deleteControl.php",{params}).pipe(map(data=>{
      return data;
    }));
  }
  
}
